import { render } from "./Intro.vue?vue&type=template&id=35ff7588&scoped=true&ts=true"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"

import "./Intro.vue?vue&type=style&index=0&id=35ff7588&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ff7588"]])

export default __exports__